import CollapsibleGroupComponent from '../../../../components/stories/molecules/collapsible-group/index.jsx'
import { iconSizeOptions } from '../../../../components/stories/atoms/icons/icons-sizes.js'
import { chevronMoveDirectionOptions } from '../../../../components/stories/molecules/collapsible-group/constants.js'
import DefineIcon from '../../../../components/stories/organisms/top-navigation/components/quick-select/components/quick-select-icons.jsx'
import { FolderContentContainer } from '../../../../components/stories/organisms/top-navigation/styled-components.js'
import { ChevronRightSmall } from '../../../../components/stories/atoms/icons/essentials/index.js'
import CustomRecursiveList from './custom-recursive-list.jsx'

export const CustomFolderItem = ({ item }) => {
  return (
    <CollapsibleGroupComponent.Item
      key={item.id}
      title={item.name}
      borderBottom={false}
      showChevronLeft={false}
      showChevronRight={true}
      chevronRightIcon={<ChevronRightSmall size={iconSizeOptions['ICON-S']} />}
      chevronMoveDirection={chevronMoveDirectionOptions.UP_TO_DOWN}
      icon={item.icon ?? <DefineIcon itemType={item.type} />}
      activeWhenOpen
      disabled={!item.active}
      style={{ minHeight: '32px' }}
    >
      <FolderContentContainer>
        <CustomRecursiveList folderId={item.id} />
      </FolderContentContainer>
    </CollapsibleGroupComponent.Item>
  )
}

export default CustomFolderItem
